import IconComponent from "icons/IconComponent";

import InstagramIcon from "./instagram-icon.svg";

export default (InstagramIcon as any) as IconComponent;
